module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_47.dot-a84deb6fef3c6ab2eaeed37f4f9ef81f.svg";